module.exports = __webpack_public_path__ + "static/img/img_0437.0cad98e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portfolio/img_0437.jpg
// module id = DsTv
// module chunks = 0